// import { useTranslation } from "react-i18next";
const Fetching = ()=>{
	// const { t } = useTranslation();
	return (
		<>
			<span>
				<i className="	fa fa-spinner w3-spin"></i> 
				<span> Đang Fetch dữ liệu</span>
			</span>
		</>
	)
}
export default Fetching